import React, { useEffect, useState } from "react";
import { Drawer } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Allapartmentcom from "./Allapartmentcom";
import AllApartClasses from "./AllApartClasses";
import getServices from "../../Services/get-service";
import Skeleton from "@mui/material/Skeleton";
import { toast } from "react-toastify";

const drawerWidth = 600;
function AllApartment({ open, handleClose, apartmentId, parentData }) {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedClassData, setSelectedClassData] = useState(null);

  const handleOpenDetails = (apt) => {
    setSelectedClassData(apt);
    setDetailsOpen(true);
  };
  const handleCloseDetails = () => setDetailsOpen(false);

  useEffect(() => {
    if (open && apartmentId) {
      setLoading(true);
      getServices
        .getApartmentClassByApartmentId(apartmentId)
        .then((response) => {
          setLoading(false);

          if (response?.data?.statusCode === 200) {
            const data = response.data.data;
            setApartments(response.data.data.apartmentClasses);
            // console.log(response.data.apartmentClasses);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.description, {
            autoClose: 1000,
          });
        });
    }
  }, [open, apartmentId]);

  return (
    <div>
      <Drawer
        anchor="right"
        variant="temporary"
        open={open}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: { xs: "100%", sm: drawerWidth },
            backgroundColor: "white",
          },
        }}
      >
        <>
          <div className=" p-4 border-b border-b-[#808285] flex justify-between">
            <p className=" text-back-color2 capitalize text-[18px] pt-3">
              All apartment classes
            </p>
            <div className="pt-2">
              <CancelIcon
                onClick={handleClose}
                className=" text-back-color2 text-[38px]"
                fontSize="large"
              />
            </div>
          </div>
          <div className=" p-3">
            {loading ? (
              <>
                {[1, 2, 3].map((item) => (
                  <div key={item} className="mb-4">
                    <Skeleton
                      variant="rectangular"
                      height={110}
                      sx={{ borderRadius: 2 }}
                    />
                  </div>
                ))}
              </>
            ) : apartments.length < 1 ? (
              <div className="text-center py-10 text-gray-500">
                No apartment class available
              </div>
            ) : (
              apartments.map((apt, index) => (
                <Allapartmentcom
                  key={index}
                  data={apt}
                  onDetailsClick={() => handleOpenDetails(apt)}
                />
              ))
            )}
          </div>
        </>
      </Drawer>
      <AllApartClasses
        open={detailsOpen}
        handleClose={handleCloseDetails}
        isProceedToPay={false}
        apartmentId={selectedClassData?.apartmentClassId}
        data={selectedClassData}
        parentData={parentData}
        closeAllApartmentDrawer={handleClose}
      />
    </div>
  );
}

export default AllApartment;
